/*! StartNoStringValidationRegion (constants for device types) */
export enum DeviceType {
  Desktop = "Desktop",
  Mobile = "Mobile",
  Tablet = "Tablet",
}
/*! EndNoStringValidationRegion */
